import { render } from "./BillDoc.vue?vue&type=template&id=fb10edf4&scoped=true"
import script from "./BillDoc.vue?vue&type=script&lang=js"
export * from "./BillDoc.vue?vue&type=script&lang=js"

import "./BillDoc.vue?vue&type=style&index=0&id=fb10edf4&scoped=true&lang=css"

import exportComponent from "E:\\zzh\\zl-h5\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fb10edf4"]])

export default __exports__